import { useContext } from 'react';
import DocumentTemplateTagContext from '../context/DocumentTemplateTagContext';

const useDocumentTemplateTagContext = () => {
  return useContext(DocumentTemplateTagContext);
};

export default useDocumentTemplateTagContext;
